// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2u18S","left":"styles_left__3zllD"};